export const highlightSQL = (sql) => {
  const keywords = [
    'SELECT', 'FROM', 'WHERE', 'JOIN', 'INNER', 'LEFT', 'RIGHT', 'OUTER', 'ON', 'AS',
    'GROUP', 'BY', 'ORDER', 'HAVING', 'INSERT', 'UPDATE', 'DELETE', 'CREATE', 'ALTER',
    'DROP', 'TABLE', 'INDEX', 'VIEW', 'PROCEDURE', 'FUNCTION', 'TRIGGER', 'DATABASE',
    'SCHEMA', 'PRIMARY', 'KEY', 'FOREIGN', 'REFERENCES', 'CONSTRAINT', 'UNIQUE',
    'NOT', 'NULL', 'DEFAULT', 'CHECK', 'WITH', 'CASE', 'WHEN', 'THEN', 'ELSE', 'END',
    'IF', 'EXISTS', 'IN', 'BETWEEN', 'LIKE', 'IS', 'AND', 'OR', 'UNION', 'ALL',
    'DISTINCT', 'TOP', 'LIMIT', 'OFFSET', 'CAST', 'CONVERT', 'COUNT', 'SUM', 'AVG',
    'MIN', 'MAX', 'SUBSTRING', 'LEN', 'DATALENGTH', 'DATEADD', 'DATEDIFF', 'GETDATE',
    'EXEC', 'EXECUTE', 'DECLARE', 'SET', 'PRINT', 'BEGIN', 'COMMIT', 'ROLLBACK',
    'TRANSACTION', 'TRY', 'CATCH', 'THROW', 'RAISERROR', 'RETURN', 'WHILE', 'BREAK',
    'CONTINUE', 'WAITFOR', 'BACKUP', 'RESTORE', 'USE', 'GO'
  ];

  const operators = ['=', '<>', '!=', '<', '>', '<=', '>=', '+', '-', '*', '/', '%'];
  const functions = ['ROW_NUMBER', 'RANK', 'DENSE_RANK', 'NTILE', 'LEAD', 'LAG', 'FIRST_VALUE', 'LAST_VALUE'];

  let highlighted = sql;

  // Highlight comments
  highlighted = highlighted.replace(/(--.*$)/gm, '<span class="sql-comment">$1</span>');
  
  // Highlight strings
  highlighted = highlighted.replace(/('([^'\\]|\\.)*')/g, '<span class="sql-string">$1</span>');
  
  // Highlight keywords
  keywords.forEach(keyword => {
    const regex = new RegExp(`\\b${keyword}\\b`, 'gi');
    highlighted = highlighted.replace(regex, `<span class="sql-keyword">${keyword.toUpperCase()}</span>`);
  });

  // Highlight functions
  functions.forEach(func => {
    const regex = new RegExp(`\\b${func}\\b`, 'gi');
    highlighted = highlighted.replace(regex, `<span class="sql-function">${func.toUpperCase()}</span>`);
  });

  // Highlight numbers
  highlighted = highlighted.replace(/\b\d+\b/g, '<span class="sql-number">$&</span>');

  // Highlight operators
  operators.forEach(op => {
    const escapedOp = op.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\s(${escapedOp})\\s`, 'g');
    highlighted = highlighted.replace(regex, ` <span class="sql-operator">$1</span> `);
  });

  return highlighted;
};